import script from "./FormBreadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./FormBreadcrumbs.vue?vue&type=script&setup=true&lang=js"

import "./FormBreadcrumbs.vue?vue&type=style&index=0&id=c4ebe6ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4ebe6ae"]])

export default __exports__